import { defaultAppConfig } from './default-app-config';

type AppEnvironment = 'stage' | 'dev';

interface IAppConstants {
  APP_ENVIRONMENT: AppEnvironment;
}

export const AppConstants: IAppConstants = {
  APP_ENVIRONMENT: 'stage',
};

export enum FeatureAppNames {
  QUICK_START_GUIDE = 'quick-start-guide',
  DEFAULT = 'default',
}

export const appsUMD = {
  [FeatureAppNames.QUICK_START_GUIDE]: defaultAppConfig.appsUMD,
  [FeatureAppNames.DEFAULT]: defaultAppConfig.appsUMD,
};

export const appsCommonsJS = {
  [FeatureAppNames.QUICK_START_GUIDE]: defaultAppConfig.appsCommonsJS,
  [FeatureAppNames.DEFAULT]: defaultAppConfig.appsCommonsJS,
};
